import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class SummaryCheckDraft extends React.Component {
  render() {
    let base = this.props.base;
    let workflow = base.workflow;
    
    if( base.check_draft.length == 0 ){
      return (
        <div className="none-draft">あなたの担当する下書きがありません</div>
      );
    }
    
    return (
      <ul className="check-drafts">
        { base.check_draft.map((d, key) => {
          let influencer = workflow.influencers[d.insta_user_id];
          if( influencer == undefined ) return null;
          
          let img = null;
          try { img = d.media[0].media_url; } catch(e) {}
          
          return (
            <a key={key} href={'/draft/'+ d.unique_id} target="_blank">
              <li>
                { (img != null)
                  ? <div className="img-thumbnail">
                      { (!Utils.isVideo(img))
                        ? <img src={img} onError={(e)=>{e.target.src=img}} />
                        : <video src={img} onError={(e)=>{e.target.src=img}} />
                      }
                    </div>
                  : <div className="img-thumbnail none" />
                }
                
                { (d.is_submission == 0) && <p className="draft-after-mark">下書き作成中</p> }
                { (d.complete == 1) && <p className="draft-after-mark">確認済み</p> }
                
                <div className="account-thumbnail">
                  { (influencer.thumbnail != null)
                    ? <img src={influencer.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} />
                    : <img src="/images/default.jpg" />
                  }
                </div>
                <div className="profile">
                  <p className="insta_id">@{influencer.insta_id}</p>
                  <p className="date">提出日：{Utils.setDate(d.create_date, 'YYYY/M/D')}</p>
                  <p className="version">Version.{d.version}</p>
                  
                  <div className="management">
                    確認中 : {d.flow_user}
                  </div>
                </div>
              </li>
            </a>
          );
        })}
      </ul>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default SummaryCheckDraft;